import { is } from '@common/is/is'

/** Támogatott az IntersectionObserver? */
export default function isIntersectionObserverSupported (): boolean {
  return is.property(window, 'IntersectionObserver')
}
